import api from "../config/api";
import { SalaryMasterLog } from "../types/SalaryMasterLog";

const API_URL = "/salaryMasterLog";

export const getAllSalariesLog = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

export const getSalaryLogById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const createSalaryLog = (data: SalaryMasterLog) =>
  api.post(`${API_URL}/`, data);

export const updateSalaryLog = (id: number, data: SalaryMasterLog) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteSalaryLog = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
